<template>
  <div class="container_news">
    <div class="banner"></div>
    <div class="container">
      <h3 class="title">新闻中心</h3>
      <Row class="news-group">
        <Col class="item" v-for="item in newsData " :xs="24" :sm="12" :key="item.id">
        <div class="item-main" @click="goDetail(item.id)">
          <div class="name">{{item.title}}</div>
          <p class="content">{{item.content}}</p>
          <div class="datetime">{{item.dateTime}}</div>
        </div>
        <div class="item-img" :style="{background:'url('+item.img+') no-repeat',backgroundSize:'cover'}"></div>
        </Col>
      </Row>
    </div>
  </div>
</template>

<script>
import newImg0 from '../../assets/news_00.png'
import newImg1 from '../../assets/new_01.jpg'
import newImg2 from '../../assets/new_02.jpg'
import newImg3 from '../../assets/new_03.jpg'
var newsSource = [{
  id: 0,
  img: newImg0,
  title: '嘉信保险经纪山东平阴分公司9.12开业庆典',
  content: '“时维九月，序属三秋”，在这样一个充满收获和希望的季节里，嘉信保险经纪山东平阴分公司的家人们怀着无比激动，无比自豪的心情共同见证了这一重要的历史时刻...',
  dateTime: '2018-09-12'
},{
  id: 1,
  img: newImg1,
  title: '车险费改再陷怪圈 肉都被渠道吃了...',
  content: '4月中下旬，多份涉及车险费率市场化改革的文件已下发至保险公司，而在前期两批共18个地区试点之后，商业车险费率改革有望全国铺开。去年6月1日起，...',
  dateTime: '2018-09-01'
}, {
  id: 2,
  img: newImg2,
  title: '乡村振兴战略下农村保险市场前景...',
  content: ' 近日，中共中央政治局召开会议，审议《乡村振兴战略规划(2018-2022年)》和《关于打赢脱贫攻坚战三年行动的指导意见》。会议指出，...',
  dateTime: '2018-09-01'
}, {
  id: 3,
  img: newImg3,
  title: '以税延优惠政策为契机 全面构建...',
  content: '近日,银保监会等部门发布《个人税收递延型商业养老保险产品开发指引》,明确税延型养老险的设计原则、交费方式、收益...',
  dateTime: '2018-09-01'
}]

export default {
  name: "index",
  data() {
    return {
      newsData: newsSource
    }
  },
  methods: {
    goDetail: function (id) {
      console.log(this.$router)
      this.$router.push(
        { path: '/newDetail', query: { id: id, type: 'news' } })
    }
  }
}
</script>
<style scoped lang="less" src="../../style/index.less"></style>
<style scoped lang="less">
@import "../../style/variable";
@media screen and (max-width: 767px) {
  .container_news {
    padding-top: 44px;
    .banner {
      height: 125px;
      background: url("./../../assets/m_news.png") no-repeat;
      background-size: cover;
    }
    .container {
      padding: 0;
      h3 {
        font-size: 16px;
        padding: 20px 20px 10px;
      }
    }
  }
}
@media screen and (min-width: 768px) {
  .container_news {
    .banner {
      height: 300px;
      background: url("./../../assets/news.jpg") no-repeat;
      background-size: cover;
    }
    .container {
      padding: 50px 0;
      h3 {
        font-size: 24px;
        padding-bottom: 20px;
      }
    }
  }
}

.container_news {
  .container {
    h3 {
      border-bottom: 1px solid #eaeaea;
    }
    .news-group {
      .item {
        position: relative;
        padding: 20px 20px 20px 170px;
        cursor: pointer;
        &:hover {
          transform: translate(-5px, -5px);
          background-color: rgba(0, 0, 0, 0.2);
        }
        .item-main {
          .name {
            color: #69c;
            font-size: 16px;
            margin-bottom: 10px;
          }
          .content {
            line-height: 32px;
            font-size: 14px;
            margin-bottom: 10px;
          }
          .datetime {
            text-align: right;
          }
        }
        .item-img {
          width: 160px;
          height: 160px;
          position: absolute;
          top: 50%;
          left: 0;
          margin-top: -80px;
          background: url("./../../assets/news.jpg") no-repeat;
          background-size: cover;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/page/News/index.vue